module.exports = __webpack_public_path__ + "static/media/series-pen-icon.01ad76ff.svg";